// Custom Quick view GA4 View_item event
document.addEventListener("click", async function (e) {
   const btn = e.target.closest(".js-quick-add");
  if (!btn || btn.dataset.action === "add-to-cart") return;

  const productId = btn.dataset.product;
  const productUrl = btn.dataset.productUrl; 
  const productHandle = productUrl.split("/products/")[1];

  let productData = null;
  try {
    const res = await fetch(`/products/${productHandle}.js`);
    productData = await res.json();
  } catch (err) {
    console.warn("Unable to fetch product details", err);
  }
 
  const payload = {
    id: productId,
    handle: productHandle,
    title: productData?.title || "",
    price: productData?.price || 0,
    vendor: productData?.vendor || "",
    type: productData?.type || "",
    variant: productData?.variants?.[0]?.title || "",
    currency: Shopify.currency.active
  };

  if (window.Shopify?.analytics?.publish) {
    Shopify.analytics.publish("quick_view", payload);
    console.log("Custom Quick View Event Published", payload);
  } else {
    console.warn(" Shopify.analytics.publish not available");
  }
});

// custom lead event for HubSpot forms
(function () {
  const path = window.location.pathname;

  const pageConfig = {
    "/pages/state-of-the-profession": {
      form_id: "eco:hc:hceu:all:gen:en:ce::2024-state-of-profession-rehab",
      form_name:
        "MKT HCEU24 US Rehab Salary Guide Download Form (E) Sept. '24",
      lead_category: "signup"
    },
     "/pages/ceu360-colibri-healthcare": {
      form_id: "CEU360 Simple Relaunch - June 2024",
      form_name:
        "CEU360 Request Demo Form - June 2024",
      lead_category: "sales"
    },
    
    "/pages/pocket-pt-toolkit": {
      form_id: "eco:hc:hceu:all:phyt:en:ce::toolkit",
      form_name:
        "MKT HCEU25 US PT Toolkit Download Form (E) Sept. '25",
      lead_category: "signup"
    }
  };

  const currentPageConfig = pageConfig[path];
  if (!currentPageConfig) return;

  window.addEventListener("message", (event) => { 
    if (!event.data) return;
    if (
      event.data.type === "hsFormCallback" &&
      event.data.eventName === "onFormSubmitted"
    ) {
      const values = event.data.data?.submissionValues || {};

      const payload = {
        form_id: currentPageConfig.form_id,
        form_name: currentPageConfig.form_name,
        lead_category: currentPageConfig.lead_category,

        user: {
          email: values.email || "",
          first_name: values.firstname || "",
          last_name: values.lastname || "",
          phone: values.phone || "" 
        }
      };

      console.log("Custom contact_lead payload:", payload);

      Shopify.analytics = Shopify.analytics || {};
      Shopify.analytics.publish =
        Shopify.analytics.publish || function () {};

      Shopify.analytics.publish("contact_lead", payload);
    }
  });
})();

